module.exports = __webpack_public_path__ + "img/领跑者流程图.8fab25a9.png";